import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { END, eventChannel } from 'redux-saga'
import agent from 'agent'
import { closeNotificationChannel, createNotificationsChannel } from 'channels/notificationsChannel'
import * as actions from 'redux/actions/app.actions'

function* connectWebSocket() {
  const state = yield select()
  const socket = yield call(agent.AppSocket.consumer, state.user.token)
  return socket
}

function channelSubscription(consumer) {
  return eventChannel(emit => {
    createNotificationsChannel(consumer, emit, END)

    // the subscriber must return an unsubscribe function
    // this will be invoked when the saga calls `channel.close` method
    const unsubscribe = () => {}
    return unsubscribe
  })
}

function* putAction(action) {
  yield put(action)
}

function deleteNotifications(params) {
  const { uuid } = params.payload
  if (document) {
    const event = new CustomEvent('notification:delete', { detail: { uuid } })
    document.dispatchEvent(event)
  }
}

function readNotifications(params) {
  const { uuids } = params.payload
  if (document) {
    const event = new CustomEvent('notification:read', { detail: { uuids } })
    document.dispatchEvent(event)
  }
}

function* connectAppNotifications() {
  const consumer = yield call(connectWebSocket)
  const channel = yield call(channelSubscription, consumer)
  yield all([
    takeLatest(channel, putAction),
    takeLatest(actions.deleteAppNotification.type, deleteNotifications),
    takeLatest(actions.readAppNotifications.type, readNotifications),
    takeLatest(actions.disconnectAppNotifications.type, () => closeNotificationChannel(consumer))
  ])
}

export default function* appSagas() {
  yield all([takeLatest(actions.connectAppNotifications.type, connectAppNotifications)])
}
